/** Remove referências de edital (ex.: "E D I T A L, página 1 -", rótulos de extração ", página N -") */
export function removerReferenciasEdital(texto) {
  if (!texto || typeof texto !== "string") return "";
  let s = texto
    .replace(
      /\s*PREGÃO\s*ELETRÔNICO\s*Nº\s*E\s*D\s*I\s*T\s*A\s*L,?\s*página\s*\d+\s*-\s*/gi,
      ""
    )
    .replace(
      /\s*E\s*D\s*I\s*T\s*A\s*L,?\s*Cláusula\s+[\d.]+,?\s*página\s*\d+\s*-\s*/gi,
      ""
    )
    .replace(/\s*EDITAL,?\s*Cláusula\s+[\d.]+,?\s*página\s*\d+\s*-\s*/gi, "")
    .replace(/\s*E\s*D\s*I\s*T\s*A\s*L,?\s*página\s*\d+\s*-\s*/gi, "")
    .replace(/\s*EDITAL,?\s*página\s*\d+\s*-\s*/gi, "")
    .replace(
      /\s*Resumo\s+do\s+Certame\s+Licitatório,?\s*página\s*\d+\s*-\s*/gi,
      ""
    )
    .replace(
      /\s*Cabeçalho\s+do\s+documento,?\s*página\s*\d+\s*-\s*/gi,
      ""
    )
    .replace(/\s*;\s*(?=\s*$)/g, "")
    .replace(/^\s*;\s*/g, "")
    .trim();

  // Rótulos genéricos de OCR/IA: "… , página N - valor"
  s = s.replace(/^\s*.+?,\s*página\s*\d+\s*-\s*/i, "").trim();

  return s;
}

/** Referente / pregão na UI e no PDF: sem prefixo indevido em placeholders da IA. */
export function formatReferentePregao(proposta) {
  const raw = proposta?.pregao_numero ?? proposta?.pregaoNumero ?? "";
  const limpo = removerReferenciasEdital(raw);
  if (!limpo) return "Não informado";
  if (
    /não\s+localizado|não\s+informado|n[aã]o\s+aplic[aá]vel|n\/d\b/i.test(
      limpo
    ) ||
    limpo.length > 120
  ) {
    return "Não informado";
  }
  if (/^PREGÃO\s*ELETRÔNICO\s*Nº\s*/i.test(limpo)) return limpo;
  return `PREGÃO ELETRÔNICO Nº ${limpo}`;
}
